var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.$store.state.LoadingShow)?_c('LayoutLoading'):_vm._e(),(_vm.$store.state.ToastShow)?_c('LayoutToast',{attrs:{"text":_vm.$store.state.ToastText}}):_vm._e(),(_vm.$store.state.DialogShow)?_c('LayoutDialog',{attrs:{"dialogData":_vm.$store.state.DialogData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }